/** @jsxImportSource theme-ui */
import React, { useState } from 'react';
import { Dropdown } from 'semantic-ui-react';

import { BdIcon } from 'components/_common/BdIcon';
import { FlexGroup } from 'components/_common/FlexGroup';
import { Typography } from 'components/_common/Typography';

import { BdDropdownOption } from '../BdDropdown';

// TODO: this is a replacement for PanelDropdown component that decouples the PanelDropdown of scrim state.
//       After refactoring work is done, please rename this to PanelDropdown and delete the old PanelDropdown

type ViewPanelDropdownProps<T extends string> = {
  options: BdDropdownOption<T>[];
  prefixLabel?: string;
  selectedValue?: T;
  expanded?: boolean;
  disabled?: boolean;
  onSelect?: (val: T) => void;
};

export function ViewPanelDropdown<T extends string>({
  options,
  prefixLabel = 'Sort by',
  selectedValue,
  expanded = false,
  disabled = false,
  onSelect,
}: React.PropsWithChildren<ViewPanelDropdownProps<T>>): React.ReactElement {
  const activeOption = options && options.find(x => x.value === selectedValue);
  const activeOptionName = activeOption && activeOption.text;
  const [isExpanded, setIsExpanded] = useState(expanded);

  // TODO: 5cf01bf7: duplicate Dropdown code, except prefix here. maybe use BdDropdown?
  const trigger = (
    <FlexGroup
      prefix={
        <>
          <BdIcon
            name="icon-sort"
            color="deepSea50"
            nomargin
            sx={{
              '&.icon.bd-icon': {
                verticalAlign: 'text-bottom',
                fontSize: '20px',
              },
            }}
          />
          <Typography color="deepSea50" variant="body2" inline sx={{ marginLeft: '7px' }}>
            {' '}
            {prefixLabel}
          </Typography>
        </>
      }
      suffix={
        <BdIcon
          name={isExpanded ? 'icon-chevron-up' : 'icon-chevron-down'}
          color="sea100"
          bold
          nomargin
          sx={{
            '&.icon.bd-icon': {
              verticalAlign: 'text-bottom',
            },
          }}
        />
      }
    >
      <Typography data-testid="activeOptionNameSortby" color="stone90" variant="subtitle2" inline>
        {activeOptionName}
      </Typography>
    </FlexGroup>
  );

  return (
    <div
      data-testid="sortby"
      sx={{
        borderBottom: theme => `1px solid ${theme.colors.stone20}`,
      }}
    >
      <Dropdown
        className="selection"
        icon={null}
        trigger={trigger}
        fluid
        options={options}
        defaultValue={selectedValue ? selectedValue.toString() : null}
        disabled={disabled}
        onChange={(_, { value }) => {
          onSelect && onSelect(value as T);
        }}
        onClose={() => setIsExpanded(false)}
        onOpen={() => setIsExpanded(true)}
      />
    </div>
  );
}
